module.exports = __webpack_public_path__ + "static/media/ZM.58873a9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ZM.svg
// module id = 396
// module chunks = 0